import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('is-IS', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount) + ' kr.';
}

export function formatDate(date: string | Date): string {
  return new Intl.DateTimeFormat('is-IS', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(date));
}

export function formatDateTime(date: string | Date): string {
  return new Intl.DateTimeFormat('is-IS', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date));
}

export function formatTime(date: string | Date): string {
  return new Intl.DateTimeFormat('is-IS', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date));
}

export function formatDuration(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export function formatPhone(phone: string): string {
  // Format Icelandic phone numbers
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.startsWith('354')) {
    const local = cleaned.slice(3);
    if (local.length === 7) {
      return `+354 ${local.slice(0, 3)} ${local.slice(3)}`;
    }
  }
  return phone;
}

export const statusLabels: Record<string, string> = {
  // Lead statuses
  nýr: 'Nýr',
  haft_samband: 'Haft samband',
  bókað: 'Bókað',
  lokað: 'Lokað',
  glatað: 'Glatað',
  
  // Property statuses
  á_markaði: 'Á markaði',
  selt: 'Selt',
  frátekið: 'Frátekið',
  afskráð: 'Afskráð',
  
  // Viewing statuses
  lokið: 'Lokið',
  aflýst: 'Aflýst',
  mætti_ekki: 'Mætti ekki',
  kom_ekki: 'Kom ekki',
  staðfest: 'Staðfest',
  
  // Call outcomes
  lead_captured: 'Lead tekið',
  viewing_booked: 'Skoðun bókuð',
  transferred: 'Tengt við mann',
  info_provided: 'Upplýsingar veittar',
  missed: 'Missti af',
  voicemail: 'Talskilaboð',
};

export const statusColors: Record<string, string> = {
  // Lead statuses
  nýr: 'badge-blue',
  haft_samband: 'badge-yellow',
  bókað: 'badge-green',
  lokað: 'badge-green',
  glatað: 'badge-red',
  
  // Property statuses
  á_markaði: 'badge-green',
  selt: 'badge-gray',
  frátekið: 'badge-yellow',
  afskráð: 'badge-gray',
  
  // Viewing statuses
  lokið: 'badge-green',
  aflýst: 'badge-red',
  mætti_ekki: 'badge-red',
  kom_ekki: 'badge-red',
  staðfest: 'badge-blue',
  
  // Call outcomes
  lead_captured: 'badge-green',
  viewing_booked: 'badge-green',
  transferred: 'badge-blue',
  info_provided: 'badge-blue',
  missed: 'badge-red',
  voicemail: 'badge-yellow',
};

export const propertyTypes: Record<string, string> = {
  íbúð: 'Íbúð',
  einbýli: 'Einbýlishús',
  einbýlishús: 'Einbýlishús',
  raðhús: 'Raðhús',
  parhús: 'Parhús',
  sumarhús: 'Sumarhús',
  atvinnuhúsnæði: 'Atvinnuhúsnæði',
};
